import { render, staticRenderFns } from "./ClosestPopulationIcon.vue?vue&type=template&id=2c6f20c6&scoped=true"
import script from "./ClosestPopulationIcon.vue?vue&type=script&lang=js"
export * from "./ClosestPopulationIcon.vue?vue&type=script&lang=js"
import style0 from "./ClosestPopulationIcon.vue?vue&type=style&index=0&id=2c6f20c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f20c6",
  null
  
)

export default component.exports